import { createGlobalStyle } from "styled-components";

// Themes Leaflet's own chrome (popups, zoom control) to match app theme.
// Shared by every full-screen dungeon map page (home, pinmonkey lobby).
export const LeafletOverrides = createGlobalStyle`
  .dungeon-popup .leaflet-popup-content-wrapper {
    background: ${({ theme }) => theme.colors("background")};
    border: 1px solid ${({ theme }) => theme.colors("foreground", 0.2)};
    border-radius: 2px;
    box-shadow: 0 0 20px ${({ theme }) => theme.colors("shadow", 0.8)};
    padding: 0;
  }
  .dungeon-popup .leaflet-popup-content {
    margin: 0;
  }
  .dungeon-popup .leaflet-popup-tip {
    background: ${({ theme }) => theme.colors("foreground", 0.2)};
  }
  .dungeon-popup .leaflet-popup-close-button {
    color: ${({ theme }) => theme.colors("foreground", 0.45)};
    font-size: 1.1rem;
    top: 4px;
    right: 6px;
  }
  .dungeon-popup .leaflet-popup-close-button:hover {
    color: ${({ theme }) => theme.colors("text")};
  }
  .leaflet-bar {
    border: 1px solid ${({ theme }) =>
      theme.colors("link", 0.5)} !important;
    border-radius: 0 !important;
    box-shadow: 0 0 20px ${({ theme }) =>
      theme.colors("shadow", 0.7)} !important;
    overflow: hidden;
  }
  .leaflet-bar a {
    background: ${({ theme }) => theme.colors("chrome")} !important;
    color: ${({ theme }) => theme.colors("foreground", 0.75)} !important;
    border-bottom: 1px solid ${({ theme }) =>
      theme.colors("link", 0.3)} !important;
    width: 30px !important;
    height: 30px !important;
    line-height: 30px !important;
    font-size: 1rem !important;
    font-family: 'Silkscreen', monospace !important;
  }
  .leaflet-bar a:hover {
    border-color: ${({ theme }) => theme.colors("link")} !important;
    color: ${({ theme }) => theme.colors("text")} !important;
  }
  .leaflet-bar a:last-child {
    border-bottom: none !important;
  }
`;
